<template>
  <b-form :class="{'navbar-searchbar-desktop-container': isDesktop}" class="d-flex justify-content-end"
          @submit.prevent="goToSearch">
    <b-input-group
      class="flex-nowrap"
      size="sm">
      <b-form-input
        :ref="'searchInput'+id"
        v-model="search"
        :class="{'active': search}"
        :placeholder="$t('Research')"
        class="search-input"
        maxlength="250"
        type="search"
        @input="onInput">
      </b-form-input>
      <b-input-group-append>
        <b-input-group-text class="search-input-append" @click="goToSearch">
          <i class="ph-custom ph-magnifying-glass"/>
        </b-input-group-text>
      </b-input-group-append>
    </b-input-group>
  </b-form>
</template>

<script>
import {debounce} from 'lodash';
import {eventBus} from "../../main";

export default {
  name: 'SearchBarForm',
  props: {
    id: "",
    isDesktop: false,
    searchInitial: null,
  },
  data() {
    return {
      search: null
    };
  },
  emits: ['didUpdateSearchText', 'didValidateSearchText'],
  created() {
    this.debouncedSearch = debounce(this.goToSearch, 700);
    eventBus.$on('focusSearchInput', this.focusSearchInput);
    eventBus.$on('resetSearchInput', this.resetSearchInput);
    eventBus.$on('resetSearchInputWithUpdateResults', this.resetSearchInputWithUpdateResults);
    eventBus.$on('refreshSearchInput', this.refreshSearchInput);
  },
  destroyed() {
    eventBus.$off('focusSearchInput', this.focusSearchInput);
    eventBus.$off('resetSearchInput', this.resetSearchInput);
    eventBus.$off('resetSearchInputWithUpdateResults', this.resetSearchInputWithUpdateResults);
    eventBus.$off('refreshSearchInput', this.refreshSearchInput);
  },
  mounted() {
    this.search = this.searchInitial;
  },
  watch: {
    search(newVal, oldVal) {
      this.$emit('didUpdateSearchText', this.search);
    }
  },
  computed: {
    isActiveRoute() {
      let domaineActive = this.$route.path.split('/')[1];
      let actionActive = this.$route.path.split('/')[2];
      return routesActiveItem => routesActiveItem ? routesActiveItem.filter(routeActiveItem => {
        let domaineRoute = routeActiveItem.split('/')[1];
        let actionRoute = routeActiveItem.split('/')[2];
        return domaineRoute === domaineActive && actionActive === actionRoute;
      }).length > 0 : false;
    },
  },
  methods: {
    focusSearchInput() {
      if (this.$refs['searchInput' + this.id]) {
        this.$refs['searchInput' + this.id].focus();
      }
    },
    async resetSearchInputWithUpdateResults() {
      await this.resetSearchInput();
      this.goToSearch(true);
    },
    resetSearchInput() {
      this.search = null;
    },
    refreshSearchInput(search) {
      this.search = search;
    },
    onInput() {
      this.debouncedSearch();
    },
    goToSearch(isClosingSearch = false) {
      if (!this.isActiveRoute(['/', '/search'])) {
        return;
      }
      if (!isClosingSearch && (!this.search || this.search.trim() === '')) {
        this.errorToast(this.$i18n.t('SearchBar.text.error.missing'));
      } else if (this.search && this.search.trim().length > 250) {
        this.errorToast(this.$i18n.t('SearchBar.text.error.too.much'));
        return;
      }

      var isAlreadyInSearch = this.isActiveRoute(['/search']);
      if (isAlreadyInSearch) {
        this.$emit('didValidateSearchText', this.search);
        eventBus.$emit("searchAnnoncesFromText", this.search);
      } else {
        this.$router.push({
          name: 'Search',
          params: {
            search: this.search
          }
        });
      }
    },
    errorToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      });
    },
  }
};
</script>
<style scoped>

.navbar-searchbar-desktop-container {
  width: 100%;
}

/* on sélectionne avec une plus grand précision sur le nom des classes: .input-group-sm>.search-input.form-control car on veut override le css qui s'ajoute tout seul en intégration/preprod/prod !!! */
.input-group-sm > .search-input.form-control {
  border-radius: var(--third-border-radius);
  font-size: var(--content-font-size) !important;
  background-color: var(--main-black-dark) !important; /* important car on veut override le css qui s'ajoute tout seul en intégration/preprod/prod ! */
  border-color: var(--main-black-light) !important; /* important car on veut override le css qui s'ajoute tout seul en intégration/preprod/prod ! */
  color: var(--main-grey-light) !important; /* important car on veut override le css qui s'ajoute tout seul en intégration/preprod/prod ! */
  height: calc(1.5em + 0.75rem + 2px) !important; /* ----------- quasi même height que les btn des filtres dans la navbar ------------ */
  min-width: 300px;
}

/* on réécrit ces propriétés qui sont déjà dans bootstrap pour que ca marche aussi en local : car en development le css de bootstrap se place après le css des component MAIS en intégration/preprod/prod il se place avant !!! */
.input-group:not(.has-validation) > .search-input.form-control:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

/* -------- finalement on garde l'option d'effacer toute la valeur de search sans pour autant fermer la barre de recherche, pour pouvoir effectuer une autre recherche si voulu ---------- */
/*!* clears the ‘X’ from Internet Explorer *!*/
/*input.search-input[type=search]::-ms-clear { display: none; width : 0; height: 0; }*/
/*input.search-input[type=search]::-ms-reveal { display: none; width : 0; height: 0; }*/
/*!* clears the ‘X’ from Chrome *!*/
/*input.search-input[type="search"]::-webkit-search-decoration,*/
/*input.search-input[type="search"]::-webkit-search-cancel-button,*/
/*input.search-input[type="search"]::-webkit-search-results-button,*/
/*input.search-input[type="search"]::-webkit-search-results-decoration { display: none; }*/

/* -------- du coup réécriture de la petite croix pour l'avoir avec la bonne couleur ---------- */
input[type="search" i]::-webkit-search-cancel-button {
  appearance: none;
  width: 16px;
  height: 16px;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 32 32' fill='%23fe0'%3e%3cpath d='M25.7071 24.2926C25.8 24.3855 25.8737 24.4958 25.924 24.6172C25.9743 24.7386 26.0001 24.8687 26.0001 25.0001C26.0001 25.1315 25.9743 25.2616 25.924 25.383C25.8737 25.5044 25.8 25.6147 25.7071 25.7076C25.6142 25.8005 25.5039 25.8742 25.3825 25.9245C25.2611 25.9747 25.131 26.0006 24.9996 26.0006C24.8682 26.0006 24.7381 25.9747 24.6167 25.9245C24.4953 25.8742 24.385 25.8005 24.2921 25.7076L15.9996 17.4138L7.70708 25.7076C7.51944 25.8952 7.26494 26.0006 6.99958 26.0006C6.73422 26.0006 6.47972 25.8952 6.29208 25.7076C6.10444 25.5199 5.99902 25.2654 5.99902 25.0001C5.99902 24.7347 6.10444 24.4802 6.29208 24.2926L14.5858 16.0001L6.29208 7.70757C6.10444 7.51993 5.99902 7.26543 5.99902 7.00007C5.99902 6.7347 6.10444 6.48021 6.29208 6.29257C6.47972 6.10493 6.73422 5.99951 6.99958 5.99951C7.26494 5.99951 7.51944 6.10493 7.70708 6.29257L15.9996 14.5863L24.2921 6.29257C24.4797 6.10493 24.7342 5.99951 24.9996 5.99951C25.2649 5.99951 25.5194 6.10493 25.7071 6.29257C25.8947 6.48021 26.0001 6.7347 26.0001 7.00007C26.0001 7.26543 25.8947 7.51993 25.7071 7.70757L17.4133 16.0001L25.7071 24.2926Z' fill='%23fe0'/%3e%3c/svg%3e");
  opacity: 1;
  cursor: pointer;
}

.search-input-append {
  cursor: pointer;
  border-top-right-radius: var(--third-border-radius) !important;
  border-bottom-right-radius: var(--third-border-radius) !important;
  border-color: var(--main-black-light);
  background-color: var(--main-black-medium);
  color: var(--main-grey-light);
}

.search-input-append:hover {
  background-color: var(--main-black-light);
}

.search-input.active {
  border-color: var(--main-yellow-medium);
}

</style>



// WEBPACK FOOTER //
// src/views/menus/SearchBarForm.vue